import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import video from '@/components/video'
import index from '@/components/index'
import poster from '@/components/poster'
import indexs from '@/components/index/index'
import indexvideo from '@/components/index/video'
import course from '@/components/index/course'
import myindex from '@/components/my/index'
import log from '@/components/my/log'
import record from '@/components/index/record'
import password from '@/components/my/password'
import forget from '@/components/my/forget'
import second from '@/components/my/second'
import newpassword from '@/components/my/newpassword'
import security from '@/components/my/security'
import publics from '@/components/index/public'
import search from '@/components/index/search'
import declareindex from '@/components/declare/index'
import declare from '@/components/declare/declare'
import studio from "@/components/index/studio.vue";
export default new Router({
	routes: [
		{
			path: '/declareindex',
			name: 'declareindex',
			component: declareindex,
			meta: {
				title: '申报记录',
			}
		},
		{
			path: '/declare',
			name: 'declare',
			component: declare,
			meta: {
				title: '我要申报',
			}
		},
		{
			path: '/video',
			name: 'video',
			component: video,
			meta: {
				title: '爱慧师苑',
			}
		},
		{
			path: '/poster',
			name: 'poster',
			component: poster,
			meta: {
				title: '海报分享',
			}
		},
		{
			path: '/',
			name: 'index',
			component: index,
			meta: {
				title: '爱慧直播',
				keepAlive: true,isBack:false
			}
		},
		{
			path: '/index',
			name: 'indexs',
			component: indexs,
			meta: {
				title: '爱慧师苑',
				keepAlive: true,isBack:false
			}
		},
		{
			path: '/indexvideo',
			name: 'indexvideo',
			component: indexvideo,
			meta: {
				title: '详情课程',
			}
		},
    {
      path: '/course',
      name: 'course',
      component: course,
      meta: {
        title: '爱慧课程',
        // keepAlive: true,isBack:false
      }
    },
    {
      path: '/studio',
      name: 'studio',
      component: studio,
      meta: {
        title: '名师工作室',
        // keepAlive: true,isBack:false
      }
    },
		{
			path: '/myindex',
			name: 'myindex',
			component: myindex,
			meta: {
				title: '个人中心',
			}
		},
		{
			path: '/log',
			name: 'log',
			component: log,
			meta: {
				title: '登录',
			}
		},
		{
			path: '/record',
			name: 'record',
			component: record,
			meta: {
				title: '观课记录',
			}
		},
		{
			path: '/password',
			name: 'password',
			component: password,
			meta: {
				title: '修改密码',
			}
		},
		{
			path: '/forget',
			name: 'forget',
			component: forget,
			meta: {
				title: '忘记密码-验证手机号',
			}
		},
		{
			path: '/second',
			name: 'second',
			component: second,
			meta: {
				title: '忘记密码-验证密保',
			}
		},
		{
			path: '/newpassword',
			name: 'newpassword',
			component: newpassword,
			meta: {
				title: '忘记密码-设置新密码',
			}
		},
		{
			path: '/security',
			name: 'security',
			component: security,
			meta: {
				title: '设置密保问题',
			}
		},
		{
			path: '/publics',
			name: 'publics',
			component: publics,
			meta: {
				title: '爱慧公益',
			}
		},
		{
			path: '/search',
			name: 'search',
			component: search,
			meta: {
				title: '搜索',
			}
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition
		} else {
			if(from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop
			}
			return {
				x: 0,
				y: to.meta.savedPosition || 0
			}
		}
	},
})



// WEBPACK FOOTER //
// ./src/router/index.js